module.exports = __webpack_public_path__ + "img/login-join-modal-icon.de190d77.svg";